
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.667 8.333a3.335 3.335 0 000 6.667 3.334 3.334 0 000-6.667zm1.1 4.9L10.333 11.8V9.667H11v1.86l1.233 1.233-.466.473zm-.434-10.9h-2.12A2.007 2.007 0 007.333 1c-.866 0-1.6.56-1.88 1.333h-2.12C2.6 2.333 2 2.933 2 3.667v10C2 14.4 2.6 15 3.333 15h4.074a4.495 4.495 0 01-.947-1.333H3.333v-10h1.334v2H10v-2h1.333v3.386c.474.067.92.207 1.334.4V3.667c0-.734-.6-1.334-1.334-1.334zm-4 1.334A.669.669 0 016.667 3c0-.367.3-.667.666-.667.367 0 .667.3.667.667 0 .367-.3.667-.667.667z","fill":"currentColor"}})])
          )
        }
      }
    